import React from 'react';
import { SectionWrapper, CTAButton, GoldDivider } from './Shared';
import { Unlock, Zap, ShieldCheck } from 'lucide-react';
export const Revelation = () => {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <SectionWrapper className="bg-prime-dark border-y border-white/5 relative overflow-hidden" data-id="element-132">
      {/* Background accent */}
      <div className="absolute right-0 top-0 w-1/2 h-full bg-gradient-to-l from-prime-gold/5 to-transparent pointer-events-none" data-id="element-133" />

      <div className="text-center mb-16 relative z-10" data-id="element-134">
        <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-135">
          La Verdad Oculta
        </h2>
        <p className="text-xl text-prime-textMuted max-w-3xl mx-auto" data-id="element-136">
          Después de analizar miles de marcadores biológicos, descubrimos algo
          revolucionario.
        </p>
      </div>

      <div className="max-w-3xl mx-auto space-y-8 text-lg text-prime-textMuted relative z-10" data-id="element-137">
        <div className="flex gap-6 items-start" data-id="element-138">
          <div className="mt-1 bg-prime-gold/10 p-2 rounded text-prime-gold" data-id="element-139">
            <Unlock className="w-6 h-6" data-id="element-140" />
          </div>
          <p data-id="element-141">
            Tu cuerpo no ha olvidado cómo producir vitalidad; simplemente está{' '}
            <strong className="text-white" data-id="element-142">
              "bloqueado" por la inflamación y la resistencia a la insulina
            </strong>
            .
          </p>
        </div>

        <div className="flex gap-6 items-start" data-id="element-143">
          <div className="mt-1 bg-prime-gold/10 p-2 rounded text-prime-gold" data-id="element-144">
            <Zap className="w-6 h-6" data-id="element-145" />
          </div>
          <p data-id="element-146">
            La mayoría de los programas de fitness fallan porque están hechos
            para jóvenes de 20 años con hormonas explosivas. Si un hombre de 45
            intenta entrenar así, termina lesionado y con el cortisol por las
            nubes, lo que{' '}
            <strong className="text-prime-redBright" data-id="element-147">
              destruye su poca testosterona restante
            </strong>
            .
          </p>
        </div>

        <div className="flex gap-6 items-start" data-id="element-148">
          <div className="mt-1 bg-prime-gold/10 p-2 rounded text-prime-gold" data-id="element-149">
            <ShieldCheck className="w-6 h-6" data-id="element-150" />
          </div>
          <p data-id="element-151">
            Necesitas un sistema de{' '}
            <strong className="text-prime-gold" data-id="element-152">Precisión Metabólica</strong>{' '}
            que trabaje CON tu biología actual, no contra ella.
          </p>
        </div>
      </div>

      <div className="mt-20 text-center relative z-10" data-id="element-153">
        <p className="text-sm uppercase tracking-[0.3em] text-prime-gold mb-4" data-id="element-154">
          Presentamos
        </p>
        <h3 className="font-serif text-5xl md:text-7xl font-bold text-white mb-12 drop-shadow-[0_0_30px_rgba(212,168,83,0.3)]" data-id="element-155">
          The Prime Architect <span className="text-prime-gold" data-id="element-156">40+</span>
        </h3>
        <CTAButton onClick={scrollToPricing} data-id="element-157">VER EL PROTOCOLO AHORA</CTAButton>
      </div>
      <GoldDivider data-id="element-158" />
    </SectionWrapper>;
};